<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row">
                                <div class="flex justify-between" style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                                    <h3 class="mb-0">Item em Estoque</h3>

                                    <div class="">
                                        <base-button :to="'/estoque-categoria'" type="info" icon="fas fa-list" size="sm" title="Categoria">Categoria</base-button>

                                        <base-button :to="'/estoque-fornecedor'" type="info" icon="fas fa-list" size="sm" title="Fornecedor">Fornecedor</base-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">
                                            <base-input alternative=""
                                                label="Descritivo"
                                                input-classes="form-control-alternative"
                                                v-model="model.descritivo"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Categoria</label>

                                                <v-select  :options="catList"  label="descritivo" class="form-control form-control-alternative" v-model="model.cat">
                                                    <template #option="option">
                                                        {{ option.descritivo }}
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">
                                            <div class="form-group has-label">
                                                <label class="form-control-label">Fornecedor</label>

                                                <v-select  :options="forList"  label="descritivo" class="form-control form-control-alternative" v-model="model.forn">
                                                    <template #option="option">
                                                        {{ option.descritivo }}
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-2">
                                            <base-input alternative=""
                                                label="Valor"
                                                input-classes="form-control-alternative"
                                                v-model="model.valor"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-2">
                                            <base-input alternative=""
                                                label="Quantidade"
                                                input-classes="form-control-alternative"
                                                v-model="model.quant"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-2 col-12">
                                            <base-input alternative=""
                                                label="Aviso de Estoque"
                                                input-classes="form-control-alternative"
                                                v-model="model.min_quant"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <input type="hidden" v-model="model.lab_id">

                                <div style="font-size: 10px; text-transform: uppercase; text-align: right;">Para remover um item, informar Quantidade e Aviso de Estoque como Zero.</div>

                                <hr class="my-4" />

                                 <div class="pl-lg-4 text-right">

                                 <template v-if="loading2">
                                    <div class="m-2">
                                    <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                    </div>
                                </template>

                                <div  v-if="!loading2">
                                 <base-button
                                    type="default"
                                    @click="salvar()"
                                    v-html="txt1"
                                    ></base-button>
                                </div>
                            </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import estoque from '@/cflow/estoque.js'
import estoqueCat from '@/cflow/estoque-cat.js'
import storage from 'storage';

import router from '@/router'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
  export default {
    name: 'tables',
    components: {
     // Multiselect,
      //BaseInput,
      vSelect
    },
    
    methods: {
        salvar: function() {

            this.loading = true;
            const _this = this;
            const _id = this.$route.params.id || '0';
            const form = this.model;

            console.log('form', form)

            form.cat_id = form.cat.id;
            form.forn_id = form.forn.id;

            estoque.salvar(_id, form).then(() => {
                _this.loading = false;
                router.push('/estoque');
                
            }).catch(() => {
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });

           
        },

        detalhes: function(_id) {
            this.loading = true; 
            const _this = this;

            estoque.detalhes(_id).then(res => {
                _this.model = res;
                this.model.lab_id = res.id_lab;
                this.valor = res.valor ? res.valor.toLocaleString('pt-br', {minimumFractionDigits: 2}) : '';
                this.loading = false;

                console.log('this.valor', this.valor)

            }).catch((error) => {
                console.err('ERROR', error);
            });
        },

        getCatList(lab_id) {
            
            Promise.all([estoqueCat.listar('CATEGORIA', lab_id), estoqueCat.listar('FORNECEDOR', lab_id)]).then( res => {
                this.catList = this.catList.concat(res[0]);
                this.forList = this.forList.concat(res[1]);
            })
        }
    },
    data() {
      return {
        txt1: 'Salvar',
        tipo: null,
        id: null,
        status: [{'nome': 'Aguardando', 'valor': 'aguardando'}, {'nome': 'Em Produção', 'valor': 'producao'}, {'nome': 'Finalizado', 'valor': 'finalizado'}],
        hasSuccess: false,
        hasError: false,
        loading: false,
        loading2: false,
        catList: [],
        forList: [],
        dated: '',
        model: {
          descritivo: '',
          quant: '',
          min_quant: '',
          lab_id: 0
        }
      }
    },

     mounted(){

        const _id = this.$route.params.id || '';
        const user = storage.get("user");

        if(_id) {
            this.detalhes(_id);
        } else {
            let lab_id = 0;
            
            if(user.tipo == 'lab') lab_id = user.id;
            this.model.lab_id = lab_id;
        }


        if(user.tipo == 'lab') {
            this.getCatList(user.id)
        }
        
      

    }
  };
</script>
<style>
.height, .ProseMirror {
    min-height: 300px;
}
.select {
    width: 100%;
    padding: 5px 5px;
}
.vs__dropdown-toggle {
    border: none !important;
}
</style>
